import { clsx } from 'clsx';
import { FC } from 'react';

import { ELEMENTS_IDS } from 'shared/components/ApplicationLayout/constants/elements-ids';

import { useCalculateMapSizes } from './internal/hooks/useCalculateMapSizes';

import styles from './MapLayout.css';

type MapLayoutProps = {
  isMapOpen: boolean;
  toggleComponent: React.ReactNode;
  map: React.ReactNode;
  mapPlaceholder: React.ReactNode;
};

export const MapLayout: FC<MapLayoutProps> = ({ isMapOpen, toggleComponent, map, mapPlaceholder }) => {
  useCalculateMapSizes();

  const openMapClasses = isMapOpen && styles['is-open'];

  return (
    <div className={clsx(styles['map-container'], openMapClasses)} id={ELEMENTS_IDS.mapContainerNodeId}>
      <section className={styles['map-wrapper']} id={ELEMENTS_IDS.mapWrapperNodeId}>
        <div className={clsx(styles['toggle-map-container'], openMapClasses)}>{toggleComponent}</div>
        {mapPlaceholder}
        <div className={clsx(styles['map-content'], openMapClasses)}>{map}</div>
      </section>
    </div>
  );
};
